var CommonLayer;
(function(CommonLayer) {
    CommonLayer[CommonLayer["DialogForeground"] = 1300] = "DialogForeground";
    CommonLayer[CommonLayer["DialogBackground"] = 1200] = "DialogBackground";
    CommonLayer[CommonLayer["Popover"] = 1000] = "Popover";
})(CommonLayer || (CommonLayer = {}));

export { CommonLayer };
